import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataStorageService {
  private initialData: any;

  setInitialData(data: any): void {
    this.initialData = data;
  }

  getInitialData(): any {
    return this.initialData;
  }
}